import { status } from 'skin/event/status';
import menuExc from './exception';

const table = (obj, form, story, data, d, action) => {
	switch (obj.table) {
		case 'menuExc':
			return menuExc(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default table;
